import React, { useEffect, useState } from "react";
import Table from "../components/ui/Table";

const Tables = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const API_BASE =
          process.env.NODE_ENV === "development"
            ? "http://localhost:7071" // Local Function URL
            : ""; // SWA API in production

        const response = await fetch(`${API_BASE}/api/getAllData`);
        let result = await response.json();

        // Sort data by timestamp in descending order
        result = result.sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));

        setData(result);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <h1 className="text-xl font-bold p-4">Data Table</h1>
      <Table data={data} />
    </div>
  );
};

export default Tables;
